
const Header = (props) => {
    const { icon1, icon2 } = props
    return (
        <>
            <div className="header_main_div">
                <div className='main_div'>
                    <div className='header_inner_div'>
                        <div>
                            {icon1}
                        </div>
                        <div>
                            {icon2}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Header